/* eslint-disable */

<template>
  <div>
    <vue-sortable>
      <div class="vx-row">
        <div class="vx-col lg:w-3/12 md:w-4/12 sm:w-5/5">
          <vx-card class="flex gap-1 w-full">
            <div>
              <h3>{{ selectedServer === 'web' ? 'Web Server' : 'CRM Server' }}</h3>
            </div>

            <div class="w-full my-8 space-y-3">
              <vs-button color="danger" class="w-full" type="border" @click="badActorsPopupOpen = true"
                >Bad Actors for the Dark Web</vs-button
              >
              <vs-button color="danger" class="w-full" type="border" @click="maliciousActivityPopupOpen = true"
                >Malicious Activity Against Peers</vs-button
              >
            </div>

            <div class="flex gap-1 w-full">
              <vs-button
                :color="selectedServer === 'web' ? 'primary' : 'grey'"
                type="filled"
                class="mb-2 w-1/2"
                @click="selectedServer = 'web'"
                >Web Server</vs-button
              >
              <vs-button
                :color="selectedServer === 'crm' ? 'primary' : 'grey'"
                type="filled"
                class="mb-2 w-1/2"
                :disabled="totalScore < 10"
                @click="selectedServer = 'crm'"
                >CRM Server</vs-button
              >
            </div>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-8/12 sm:w-5/5">
          <div style="height: 35rem">
            <vue-command
              v-show="selectedServer === 'web'"
              key="web-server"
              id="web_server_command_prompt"
              :commands="webCommands"
              :prompt="'[root@webserver ~]# '"
              :show-intro="true"
              class=""
              :intro="'Web Server Terminal - NorthBridge Bank Security Operations'"
              style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem"
              :title="'Web Server Command Prompt'"
            />
            <vue-command
              v-show="selectedServer === 'crm'"
              key="crm-server"
              id="crm_server_command_prompt"
              :commands="crmCommands"
              :prompt="'[root@crmserver ~]# '"
              :show-intro="true"
              class=""
              :intro="'CRM Server Terminal - NorthBridge Bank Security Operations'"
              style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem"
              :title="'CRM Server Command Prompt'"
            />
          </div>
        </div>
      </div>
    </vue-sortable>

    <movable-popup
      refVal="badActorsPopup"
      :title="'Bad Actors for the Dark Web - Click Here to Drag This Popup'"
      :active="badActorsPopupOpen"
      v-on:close="badActorsPopupOpen = false"
      padding="0px"
    >
      <template v-slot:content>
        <div class="bg-dark p-3 main-border rounded-lg flex flex-col">
          <div class="grid grid-cols-5 gap-6 font-medium pb-2">
            <span style="line-height: 2rem">Source IP Address</span>
            <span style="line-height: 2rem">Service</span>
            <span style="line-height: 2rem">Confidence Level</span>
            <span style="line-height: 2rem">Attack Frequency</span>
            <span style="line-height: 2rem">Industry Vertical</span>
          </div>

          <div class="grid gap-x-6 gap-y-1">
            <span
              class="terminal-line text-grey grid grid-cols-5 gap-6 py-1 main-top-border"
              style="line-height: 2rem"
              v-for="(item, index) in badActorContents"
              :key="index"
            >
              <span>{{ item[0] }}</span>
              <span>{{ item[1] }}</span>
              <span>{{ item[2] }}</span>
              <span>{{ item[3] }}</span>
              <span>{{ item[4] }}</span>
            </span>
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup
      refVal="maliciousActivityPopup"
      :title="'Malicious Activity Against Peers - Click Here to Drag This Popup'"
      :active="maliciousActivityPopupOpen"
      v-on:close="maliciousActivityPopupOpen = false"
      padding="0px"
    >
      <template v-slot:content>
        <div class="bg-dark p-3 main-border rounded-lg flex flex-col">
          <div class="grid grid-cols-5 gap-6 font-medium pb-2">
            <span style="line-height: 2rem">Source IP Address</span>
            <span style="line-height: 2rem">Service</span>
            <span style="line-height: 2rem">Confidence Level</span>
            <span style="line-height: 2rem">Attack Frequency</span>
            <span style="line-height: 2rem">Verified/Unverified</span>
          </div>

          <div class="grid gap-x-6 gap-y-1">
            <span
              class="terminal-line text-grey grid grid-cols-5 gap-6 py-1 main-top-border"
              style="line-height: 2rem"
              v-for="(item, index) in maliciousActivityContents"
              :key="index"
            >
              <span>{{ item[0] }}</span>
              <span>{{ item[1] }}</span>
              <span>{{ item[2] }}</span>
              <span>{{ item[3] }}</span>
              <span>{{ item[4] }}</span>
            </span>
          </div>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import VueCommand, { createStdout, createStderr } from 'vue-command';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';
import 'vue-command/dist/vue-command.css';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      totalScore: 0,
      selectedServer: 'web',

      // Track executed commands to prevent duplicate scoring
      executedCommands: new Set(),
      executedCommandsCount: new Map(),

      badActorsPopupOpen: false,
      maliciousActivityPopupOpen: false,

      badActorContents: [
        ['52.104.29.42', 'HTTPS', 'High', 'Medium', 'Retail'],
        ['52.104.29.42', 'DNS', 'High', 'Low', 'Retail'],
        ['28.47.62.125', 'HTTPS', 'Low', 'Medium', 'Retail'],
        ['110.12.213.189', 'HTTPS', 'Medium', 'Low', 'Banking'],
        ['36.220.4.27', 'MSSQL', 'Low', 'High', 'Banking'],
        ['36.220.4.27', 'SSH', 'Low', 'Low', 'Banking'],
        ['36.220.4.27', 'VNC', 'High', 'Low', 'Healthcare'],
        ['66.101.22.80', 'FTP', 'High', 'Medium', 'Healthcare'],
        ['66.101.22.180', 'HTTPS', 'High', 'High', 'Healthcare'],
        ['--', 'HTTPS', 'Low', '--', 'Education'],
      ],

      maliciousActivityContents: [
        ['147.68.169.52', 'HTTPS', 'Medium', 'High', 'Unverified'],
        ['52.89.48.52', 'HTTPS', 'High', 'High', 'Unverified'],
        ['76.17.89.65', 'MSSQL', 'Low', 'Low', 'Unverified'],
        ['83.67.47.57', 'SFTP', 'Medium', 'Medium', 'Unverified'],
        ['51.65.12.24', 'LDAP', 'Low', 'Low', 'Unverified'],
        ['3.60.19.62', 'HTTPS', 'High', 'High', 'Unverified'],
        ['24.64.19.25', 'DNS', 'Low', 'Medium', 'Unverified'],
        ['97.19.78.54', 'HTTPS', 'Medium', 'Low', 'Unverified'],
        ['193.28.47.78', 'VNC', 'High', 'High', 'Unverified'],
        ['99.30.17.99', 'RDP', 'Low', 'Low', 'Unverified'],
      ],

      // Web Server Data
      webActiveConnections: [
        { proto: 'TCP', local: '127.0.0.1:59006', foreign: '127.0.0.1:59007', state: 'ESTABLISHED', pid: 5404 },
        { proto: 'TCP', local: '127.0.0.1:59007', foreign: '127.0.0.1:59006', state: 'ESTABLISHED', pid: 5404 },
        { proto: 'TCP', local: '127.0.0.1:51624', foreign: '130.0.0.89:3389', state: 'ESTABLISHED', pid: 9264 },
        { proto: 'TCP', local: '110.12.213.189:65001', foreign: '172.0.0.1:42881', state: 'ESTABLISHED', pid: 2207 },
        { proto: 'TCP', local: '127.0.0.1:42881', foreign: '110.12.213.189:443', state: 'ESTABLISHED', pid: 2207 },
        { proto: 'TCP', local: '127.0.0.1:8080', foreign: '52.89.48.52:3207', state: 'ESTABLISHED', pid: 1158 },
        { proto: 'TCP', local: '127.0.0.1:8080', foreign: '72.55.27.57:1275', state: 'ESTABLISHED', pid: 3207 },
      ],

      webProcessFiles: {
        2207: [
          {
            command: 'malware',
            pid: '2207',
            user: 'www-data',
            fd: 'cwd',
            type: 'DIR',
            device: '202,1',
            size: '4096',
            node: '2',
            name: '/tmp/malicious',
          },
          {
            command: 'malware',
            pid: '2207',
            user: 'www-data',
            fd: 'txt',
            type: 'REG',
            device: '202,1',
            size: '87432',
            node: '15847',
            name: '/tmp/malicious/backdoor.exe',
          },
          {
            command: 'malware',
            pid: '2207',
            user: 'www-data',
            fd: '3u',
            type: 'IPv4',
            device: '0x0',
            size: '0t0',
            node: 'TCP',
            name: '110.12.213.189:65001->172.0.0.1:42881 (ESTABLISHED)',
          },
          {
            command: 'malware',
            pid: '2207',
            user: 'www-data',
            fd: '4u',
            type: 'IPv4',
            device: '0x0',
            size: '0t0',
            node: 'TCP',
            name: '127.0.0.1:42881->110.12.213.189:443 (ESTABLISHED)',
          },
        ],
        1158: [
          {
            command: 'trojan',
            pid: '1158',
            user: 'nginx',
            fd: 'cwd',
            type: 'DIR',
            device: '202,1',
            size: '4096',
            node: '2',
            name: '/var/www/html/uploads',
          },
          {
            command: 'trojan',
            pid: '1158',
            user: 'nginx',
            fd: 'txt',
            type: 'REG',
            device: '202,1',
            size: '124896',
            node: '20489',
            name: '/var/www/html/uploads/shell.php',
          },
          {
            command: 'trojan',
            pid: '1158',
            user: 'nginx',
            fd: '5u',
            type: 'IPv4',
            device: '0x0',
            size: '0t0',
            node: 'TCP',
            name: '127.0.0.1:8080->52.89.48.52:3207 (ESTABLISHED)',
          },
        ],
      },

      // Web Server Service status tracking
      webServiceStatus: {
        httpd: 'running',
        nginx: 'running',
      },

      // Web Server killed processes
      webKilledProcesses: [],

      // CRM Server Data
      crmProcesses: [
        { pid: 1, tty: '?', time: '00:00:15', cmd: 'init' },
        { pid: 2, tty: '?', time: '00:00:00', cmd: 'kthreadd' },
        { pid: 3, tty: '?', time: '00:00:00', cmd: 'migration/0' },
        { pid: 5, tty: '?', time: '00:00:00', cmd: 'watchdog/0' },
        { pid: 6, tty: '?', time: '00:00:00', cmd: 'migration/1' },
        { pid: 7, tty: '?', time: '00:00:00', cmd: 'ksoftirqd/1' },
        { pid: 8, tty: '?', time: '00:00:00', cmd: 'watchdog/1' },
        { pid: 9, tty: '?', time: '00:00:00', cmd: 'events/0' },
        { pid: 10, tty: '?', time: '00:00:00', cmd: 'events/1' },
        { pid: 15, tty: '?', time: '00:00:01', cmd: 'kintegrityd/0' },
        { pid: 17, tty: '?', time: '00:00:00', cmd: 'kintegrityd/1' },
        { pid: 19, tty: '?', time: '00:00:00', cmd: 'kblockd/0' },
        { pid: 20, tty: '?', time: '00:00:00', cmd: 'kblockd/1' },
        { pid: 21, tty: '?', time: '00:00:00', cmd: 'kacpid' },
        { pid: 22, tty: '?', time: '00:00:00', cmd: 'kacpi_notify' },
        { pid: 23, tty: '?', time: '00:00:27', cmd: 'ata/0' },
        { pid: 24, tty: '?', time: '00:00:00', cmd: 'ata/1' },
        { pid: 33, tty: '?', time: '00:00:00', cmd: 'ata_aux' },
        { pid: 34, tty: '?', time: '00:00:00', cmd: 'crypto/0' },
        { pid: 46, tty: '?', time: '00:00:00', cmd: 'crypto/1' },
        { pid: 77, tty: '?', time: '00:00:00', cmd: 'scsi_eh_0' },
        { pid: 84, tty: '?', time: '00:00:00', cmd: 'scsi_eh_1' },
        { pid: 95, tty: '?', time: '00:00:00', cmd: 'scsi_eh_2' },
        { pid: 937, tty: '?', time: '00:00:00', cmd: 'kjournald2' },
        { pid: 1158, tty: '?', time: '00:00:18', cmd: 'kjournald' },
        { pid: 1358, tty: '?', time: '00:00:00', cmd: 'kauditd' },
        { pid: 1447, tty: '?', time: '00:00:18', cmd: 'kjournald' },
        { pid: 1449, tty: '?', time: '00:00:00', cmd: 'httpd' },
        { pid: 1480, tty: '?', time: '00:00:23', cmd: 'httpd' },
        { pid: 1652, tty: '?', time: '00:00:17', cmd: 'auditd' },
        { pid: 1713, tty: '?', time: '00:00:00', cmd: 'auglspd' },
        { pid: 1761, tty: '?', time: '00:00:00', cmd: 'network' },
        { pid: 1776, tty: '?', time: '00:00:00', cmd: 'acpid' },
        { pid: 1882, tty: '?', time: '00:00:00', cmd: 'wpa_supplicant' },
        { pid: 2071, tty: '?', time: '00:00:00', cmd: 'bluetoothd' },
        { pid: 2077, tty: '?', time: '00:00:10', cmd: 'bluetooth' },
        { pid: 2081, tty: '?', time: '00:00:15', cmd: 'ntpd' },
        { pid: 2077, tty: '?', time: '00:00:00', cmd: 'crond' },
        { pid: 2200, tty: '?', time: '00:00:00', cmd: 'mysqld' },
        { pid: 3343, tty: '?', time: '00:00:00', cmd: 'named' },
        { pid: 3758, tty: '?', time: '00:00:23', cmd: 'atd' },
        { pid: 3759, tty: '?', time: '00:00:18', cmd: 'vncsrv' },
        { pid: 3840, tty: '?', time: '00:00:00', cmd: 'sshd' },
        { pid: 5829, tty: '?', time: '00:00:00', cmd: 'bash' },
        { pid: 8080, tty: '?', time: '00:00:15', cmd: 'ps' },
        { pid: 9000, tty: '?', time: '00:00:00', cmd: 'sendmail' },
        { pid: 9001, tty: '?', time: '00:00:00', cmd: 'lpd' },
      ],

      crmServices: {
        NetworkManager: '3:off',
        atd: '3:on',
        auditd: '3:on',
        'avahi-daemon': '3:on',
        bluetooth: '3:on',
        cpuspeed: '3:on',
        crond: '3:on',
        httpd: '3:on',
        ip6tables: '3:on',
        iptables: '3:off',
        irda: '3:on',
        irqbalance: '3:on',
        lm_sensors: '3:off',
        lpd: '3:off',
        microcode_ctl: '3:off',
        multipathd: '3:on',
        mysqld: '3:on',
        netconsole: '3:off',
        netfs: '3:on',
        netplugd: '3:off',
        network: '3:on',
        nfs: '3:off',
        nfslock: '3:on',
        nscd: '3:on',
        ntpd: '3:on',
        ntpdate: '3:off',
        restorecond: '3:off',
        rpcbind: '3:off',
        rpcgssd: '3:off',
        rpcidmapd: '3:on',
        rpcsvcgssd: '3:on',
        rsyslog: '3:on',
        sendmail: '3:on',
        vncserver: '3:on',
      },

      crmServiceStatus: {
        httpd: 'running',
        mysqld: 'running',
        sendmail: 'running',
        vncserver: 'running',
      },

      crmKilledProcesses: [],

      // Web Server Commands
      webCommands: {
        help: () => {
          return createStdout(
            'Available commands:<br>&nbsp;kill -9 [pid]<br>&nbsp;ls -l<br>&nbsp;lsof [-p pid] [-i @ip]<br>&nbsp;netstat -o<br>&nbsp;service [service name] [start|stop|restart]',
          );
        },

        netstat: (x) => {
          if (!x.o || x.length > 1) {
            return createStderr('Invalid Usage: netstat -o');
          }

          let output = `Available Connections:<br>
Proto&nbsp;&nbsp;Local Address          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Foreign Address        &nbsp;&nbsp;&nbsp;&nbsp;State           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PID<br>`;

          this.webActiveConnections.forEach((conn) => {
            const localPadded = conn.local.padEnd(25);
            const foreignPadded = conn.foreign.padEnd(25);
            const statePadded = conn.state.padEnd(15);

            output += `${conn.proto}&nbsp;&nbsp;&nbsp;&nbsp;${localPadded}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${foreignPadded}&nbsp;&nbsp;&nbsp;&nbsp;${statePadded}&nbsp;&nbsp;${conn.pid}<br>`;
          });

          // Use the new method instead of manual increment
          this.incrementScoreTwice('web-netstat');

          return createStdout(output);
        },

        kill: (x) => {
          if (x[9] === undefined) {
            return createStderr('Invalid Usage: kill -9 [pid]');
          }

          const pidToKill = x[9];
          const connectionExists = this.webActiveConnections.some((conn) => conn.pid == pidToKill);
          const processExists = this.webProcessFiles[pidToKill];

          if (!connectionExists && !processExists) {
            return createStderr('Invalid PID Specified');
          }

          if (!this.webKilledProcesses.includes(pidToKill)) {
            this.webKilledProcesses.push(pidToKill);
          }

          const initialLength = this.webActiveConnections.length;
          this.webActiveConnections = this.webActiveConnections.filter((conn) => conn.pid != pidToKill);
          const removedCount = initialLength - this.webActiveConnections.length;

          if (this.webProcessFiles[pidToKill]) {
            delete this.webProcessFiles[pidToKill];
          }

          this.incrementScoreOnce(`web-kill-${pidToKill}`);
          return createStdout(`Process ${pidToKill} terminated. ${removedCount} connection(s) closed.`);
        },

        lsof: (x) => {
          if (x.p !== undefined) {
            const pid = x.p.toString();

            if (this.webKilledProcesses.includes(pid)) {
              this.incrementScoreOnce(`web-lsof-p-${pid}`);
              return createStderr(`lsof: no process specified`);
            }

            if (!this.webProcessFiles[pid]) {
              this.incrementScoreOnce(`web-lsof-p-${pid}`);
              return createStderr(`lsof: no process specified`);
            }

            let output = `COMMAND&nbsp;&nbsp;&nbsp;&nbsp;PID&nbsp;&nbsp;&nbsp;&nbsp;USER&nbsp;&nbsp;&nbsp;&nbsp;FD&nbsp;&nbsp;&nbsp;&nbsp;TYPE&nbsp;&nbsp;&nbsp;&nbsp;DEVICE&nbsp;&nbsp;&nbsp;&nbsp;SIZE/OFF&nbsp;&nbsp;&nbsp;&nbsp;NODE NAME<br>`;

            this.webProcessFiles[pid].forEach((file) => {
              output += `${file.command.padEnd(12)}${file.pid.padEnd(8)}${file.user.padEnd(8)}${file.fd.padEnd(6)}${file.type.padEnd(
                8,
              )}${file.device.padEnd(10)}${file.size.padEnd(12)}${file.node.padEnd(8)}${file.name}<br>`;
            });

            this.incrementScoreOnce(`web-lsof-p-${pid}`);

            return createStdout(output);
          }

          if (x.i !== undefined && x.i.toString().startsWith('@')) {
            const targetIp = x.i.toString().substring(1);

            let output = `COMMAND&nbsp;&nbsp;&nbsp;&nbsp;PID&nbsp;&nbsp;&nbsp;&nbsp;USER&nbsp;&nbsp;&nbsp;&nbsp;FD&nbsp;&nbsp;&nbsp;&nbsp;TYPE&nbsp;&nbsp;&nbsp;&nbsp;DEVICE&nbsp;&nbsp;&nbsp;&nbsp;SIZE/OFF&nbsp;&nbsp;&nbsp;&nbsp;NODE NAME<br>`;

            this.webActiveConnections.forEach((conn) => {
              const pidStr = conn.pid.toString();
              const localIp = conn.local.split(':')[0];
              const foreignIp = conn.foreign.split(':')[0];
              const hasTargetIp = localIp === targetIp || foreignIp === targetIp;

              if (hasTargetIp && !this.webKilledProcesses.includes(pidStr)) {
                const commandName = pidStr === '2207' ? 'malware' : pidStr === '1158' ? 'trojan' : 'process';
                const user = pidStr === '2207' ? 'www-data' : pidStr === '1158' ? 'nginx' : 'root';

                output += `${commandName.padEnd(12)}${pidStr.padEnd(8)}${user.padEnd(8)}3u${' '.repeat(4)}IPv4${' '.repeat(
                  4,
                )}0x0${' '.repeat(7)}0t0${' '.repeat(9)}TCP ${conn.local}->${conn.foreign} (${conn.state})<br>`;
              }
            });

            this.incrementScoreOnce(`web-lsof-i-${targetIp}`);

            return createStdout(output);
          }

          if (Object.keys(x).length === 1 && x._ && x._.length === 1 && x._[0] === 'lsof') {
            this.incrementScoreOnce('web-lsof-all');

            return createStdout(`
COMMAND&nbsp;&nbsp;&nbsp;&nbsp;PID&nbsp;&nbsp;&nbsp;&nbsp;USER&nbsp;&nbsp;&nbsp;&nbsp;FD&nbsp;&nbsp;&nbsp;&nbsp;TYPE&nbsp;&nbsp;&nbsp;&nbsp;DEVICE&nbsp;&nbsp;&nbsp;&nbsp;SIZE/OFF&nbsp;&nbsp;&nbsp;&nbsp;NODE NAME<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;cwd&nbsp;&nbsp;&nbsp;DIR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4096&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 /<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;rtd&nbsp;&nbsp;&nbsp;DIR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4096&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2 /<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;txt&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1577696&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2016 /lib/systtemd/systemd<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;47640&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7292 /lib/x86_64-linux-gnu/libnss_files-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;47640&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7296 /lib/x86_64-linux-gnu/libnss_nis-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;47640&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7300 /lib/x86_64-linux-gnu/libnss_compat-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;931488&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2013 /lib/x86_64-linux-gnu/libm-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1017208&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2015 /lib/x86_64-linux-gnu/libpthread-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;162280&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2018 /lib/x86_64-linux-gnu/libdl-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;456696&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2012 /lib/x86_64-linux-gnu/libpcre.so.3.13.2<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1486880&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2014 /lib/x86_64-linux-gnu/libc-2.23.so<br>
systemd&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root&nbsp;&nbsp;&nbsp;&nbsp;mem&nbsp;&nbsp;&nbsp;REG&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;202,1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;138696&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2020 /lib/x86_64-linux-gnu/libgcc_s.so.1<br>
            `);
          }

          return createStderr('Invalid Usage: lsof [-p pid] [-i @ip]');
        },

        service: (x) => {
          const args = x._ ? x._.slice(1) : [];

          if (args.length !== 2) {
            return createStderr('Invalid Usage: service [service name] [start|stop|restart]');
          }

          const serviceName = args[0];
          const action = args[1];

          if (!['httpd', 'nginx'].includes(serviceName)) {
            return createStderr(`service: ${serviceName}: unrecognized service`);
          }

          if (!['start', 'stop', 'restart'].includes(action)) {
            return createStderr('Invalid action. Use: start, stop, or restart');
          }

          this.incrementScoreOnce(`web-service-${serviceName}-${action}`);

          switch (action) {
            case 'stop':
              this.webServiceStatus[serviceName] = 'stopped';
              return createStdout(`Stopping ${serviceName}: [  OK  ]`);

            case 'start':
              if (this.webServiceStatus[serviceName] === 'running') {
                return createStdout(`${serviceName}: already running`);
              }
              this.webServiceStatus[serviceName] = 'running';
              return createStdout(`Starting ${serviceName}: [  OK  ]`);

            case 'restart':
              this.webServiceStatus[serviceName] = 'stopped';
              setTimeout(() => {
                this.webServiceStatus[serviceName] = 'running';
              }, 100);
              return createStdout(`Stopping ${serviceName}: [  OK  ]<br>Starting ${serviceName}: [  OK  ]`);

            default:
              return createStderr('Invalid action');
          }
        },

        ls: (x) => {
          if (!x.l) {
            return createStderr('Invalid Usage: ls -l');
          }

          this.incrementScoreOnce('web-ls-l');

          return createStdout(`
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;18     &nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;4096 Feb &nbsp;5 09:36 .<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;5     &nbsp;&nbsp;root     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;root     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;50 Feb &nbsp;&nbsp;&nbsp;2 15:51 ..<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;6 Feb &nbsp;&nbsp;&nbsp;&nbsp;2 13:41 Desktop<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;3     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;26 Feb &nbsp;&nbsp;&nbsp;5 09:42 Documents<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;53 Feb &nbsp;&nbsp;&nbsp;5 09:42 Downloads<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;3     &nbsp;&nbsp;nginx     &nbsp;&nbsp;&nbsp;&nbsp;nginx     &nbsp;&nbsp;&nbsp;&nbsp;99 Feb &nbsp;&nbsp;&nbsp;5 09:20 html<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;6 Feb &nbsp;&nbsp;&nbsp;&nbsp;2 10:52 Music<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;6 Feb &nbsp;&nbsp;&nbsp;&nbsp;2 10:52 Pictures<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;6 Feb &nbsp;&nbsp;&nbsp;&nbsp;2 10:52 Public<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;6 Feb &nbsp;&nbsp;&nbsp;&nbsp;2 10:52 Templates<br>
drwxr-xr-x.     &nbsp;&nbsp;&nbsp;&nbsp;2     &nbsp;&nbsp;comptia     &nbsp;&nbsp;comptia     &nbsp;&nbsp;6 Feb &nbsp;&nbsp;&nbsp;&nbsp;2 10:52 Videos<br>
          `);
        },
      },

      // CRM Server Commands
      crmCommands: {
        help: () => {
          return createStdout(
            'Available commands:<br>&nbsp;chkconfig --list<br>&nbsp;kill -9 [pid]<br>&nbsp;ps -A<br>&nbsp;service [service name] [start|stop|restart]',
          );
        },

        ps: (x) => {
          if (!x.A && !(x._ && x._[1] === '-A')) {
            return createStderr('Invalid Usage: ps -A');
          }

          let output = `PID TTY&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TIME CMD<br>`;

          this.crmProcesses.forEach((proc) => {
            if (!this.crmKilledProcesses.includes(proc.pid.toString())) {
              const pidPadded = proc.pid.toString().padEnd(4);
              const ttyPadded = proc.tty.padEnd(8);
              const timePadded = proc.time.padEnd(8);
              output += `${pidPadded}${ttyPadded}&nbsp;&nbsp;${timePadded}${proc.cmd}<br>`;
            }
          });

          // Use the new method instead of manual increment
          this.incrementScoreTwice('crm-ps');

          return createStdout(output);
        },

        chkconfig: (x) => {
          if (!x.list && !(x._ && x._[1] === '--list')) {
            return createStderr('Invalid Usage: chkconfig --list');
          }

          let output = '';
          Object.keys(this.crmServices).forEach((service) => {
            const servicePadded = service.padEnd(20);
            output += `${servicePadded}${this.crmServices[service]}<br>`;
          });

          this.incrementScoreOnce('crm-chkconfig-list');

          return createStdout(output);
        },

        kill: (x) => {
          if (x[9] === undefined) {
            return createStderr('Invalid Usage: kill -9 [pid]');
          }

          const pidToKill = x[9];
          const processExists = this.crmProcesses.some((proc) => proc.pid === pidToKill);

          if (!processExists) {
            return createStderr('Invalid PID Specified');
          }

          if (!this.crmKilledProcesses.includes(pidToKill)) {
            this.crmKilledProcesses.push(pidToKill);
          }

          // Update service status if killing specific services
          if (pidToKill === 3759) {
            // vncsrv
            this.incrementScoreOnce(`crm-kill-${pidToKill}`);
            this.crmServiceStatus.vncserver = 'stopped';
          } else {
            this.incrementScoreOnce(`crm-kill-${pidToKill}`);
          }

          return createStdout(`Process ${pidToKill} terminated.`);
        },

        service: (x) => {
          const args = x._ ? x._.slice(1) : [];

          if (args.length !== 2) {
            return createStderr('Invalid Usage: service [service name] [start|stop|restart]');
          }

          const serviceName = args[0];
          const action = args[1];

          if (!['sendmail', 'vncserver'].includes(serviceName)) {
            return createStderr(`service: ${serviceName}: unrecognized service`);
          }

          if (!['start', 'stop', 'restart'].includes(action)) {
            return createStderr('Invalid action. Use: start, stop, or restart');
          }

          this.incrementScoreOnce(`crm-service-${serviceName}-${action}`);

          switch (action) {
            case 'stop':
              this.crmServiceStatus[serviceName] = 'stopped';

              // Kill the associated processes when stopping services
              if (serviceName === 'sendmail') {
                // Kill sendmail process (PID 9000)
                if (!this.crmKilledProcesses.includes('9000')) {
                  this.crmKilledProcesses.push('9000');
                }
              } else if (serviceName === 'vncserver') {
                // Kill vncsrv process (PID 3759)
                if (!this.crmKilledProcesses.includes('3759')) {
                  this.crmKilledProcesses.push('3759');
                }
              }

              return createStdout(`Stopping ${serviceName}: [  OK  ]`);

            case 'start':
              if (this.crmServiceStatus[serviceName] === 'running') {
                return createStdout(`${serviceName}: already running`);
              }
              this.crmServiceStatus[serviceName] = 'running';

              // Remove from killed processes list when starting services
              if (serviceName === 'sendmail') {
                const index = this.crmKilledProcesses.indexOf('9000');
                if (index > -1) {
                  this.crmKilledProcesses.splice(index, 1);
                }
              } else if (serviceName === 'vncserver') {
                const index = this.crmKilledProcesses.indexOf('3759');
                if (index > -1) {
                  this.crmKilledProcesses.splice(index, 1);
                }
              }

              return createStdout(`Starting ${serviceName}: [  OK  ]`);

            case 'restart':
              this.crmServiceStatus[serviceName] = 'stopped';

              // Kill processes during restart
              if (serviceName === 'sendmail') {
                if (!this.crmKilledProcesses.includes('9000')) {
                  this.crmKilledProcesses.push('9000');
                }
              } else if (serviceName === 'vncserver') {
                if (!this.crmKilledProcesses.includes('3759')) {
                  this.crmKilledProcesses.push('3759');
                }
              }

              setTimeout(() => {
                this.crmServiceStatus[serviceName] = 'running';

                // Remove from killed processes list after restart
                if (serviceName === 'sendmail') {
                  const index = this.crmKilledProcesses.indexOf('9000');
                  if (index > -1) {
                    this.crmKilledProcesses.splice(index, 1);
                  }
                } else if (serviceName === 'vncserver') {
                  const index = this.crmKilledProcesses.indexOf('3759');
                  if (index > -1) {
                    this.crmKilledProcesses.splice(index, 1);
                  }
                }
              }, 100);

              return createStdout(`Stopping ${serviceName}: [  OK  ]<br>Starting ${serviceName}: [  OK  ]`);

            default:
              return createStderr('Invalid action');
          }
        },
      },
    };
  },

  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },

  methods: {
    incrementScoreOnce(commandKey) {
      if (!this.executedCommands.has(commandKey)) {
        this.executedCommands.add(commandKey);
        this.totalScore++;
        this.$emit('simulation_update_score', this.totalScore);
      }
    },
    incrementScoreTwice(commandKey) {
      const currentCount = this.executedCommandsCount.get(commandKey) || 0;

      if (currentCount < 2) {
        this.executedCommandsCount.set(commandKey, currentCount + 1);
        this.totalScore++;
        this.$emit('simulation_update_score', this.totalScore);
      }
    },
  },

  components: {
    Prism,
    VueCommand,
    MovablePopup,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
.vx-card__collapsible-content {
  width: 100%;
}
</style>
